import { defineComponent as _defineComponent } from 'vue'
import DataTableWrapper from "@/components/commons/DataTableWrapper.vue";
import {computed, ref} from "vue";
import {useUserStore} from "@/store/user.store";
import {EagerLoadingConfig} from "@/components/commons/EagerLoadingConfig";
import CoinAmount from "../commons/CoinAmount.vue";
import PercentsView from "@/components/commons/PercentsView.vue";
import {Coin} from "@/models/store/common";
import {LoyaltyDropPoolConfig, LoyaltyDropUserBoost} from "@/models/store/loyaltyDrop";
import LoyaltyDropPopup from "@/components/loyaltyDrop/LoyaltyDropPopup.vue";
import {useLoyaltyDropStore} from "@/store/boost.store";
import StakeManagementIcon from "@/components/commons/StakeManagementIcon.vue";
import {BigDecimal, divideBigInts} from "@/models/store/big.decimal";
import {UnbondingDelegationEntry} from "@/models/store/staking";
import {calculateApr, calculatePayouts} from "./LoialtyDropUtil";
import Counter from "@/components/booster/BoosterCounter.vue";
import BoosterCounter from "@/components/booster/BoosterCounter.vue";
import StatusBadge from "@/components/booster/StatusBadge.vue";
import Icon from "@/components/features/IconComponent.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'LoyaltyDropDataTable',
  setup(__props, { expose: __expose }) {
  __expose();


async function transactionSuccess(arg: string) {
  popupOpened.value = !popupOpened.value;
}




const popupOpened = ref(false);
const currentBoost = ref<LoyaltyDropPoolConfig>();


const userStore = useUserStore();
const boostStore = useLoyaltyDropStore();
const isLoggedIn = computed(() => userStore.isLoggedIn);
const expandedRow = ref(Array<LoyaltyDropPoolConfig>());

function test(ttt){
  console.log("!!!TTT" +  JSON.stringify(ttt));
}

function calculateRockets(str: string) {
  if (str.indexOf('3m') >= 0) {
    return 1;
  }
  if (str.indexOf('6m') >= 0) {
    return 2;
  }
  if (str.indexOf('9m') >= 0) {
    return 3;
  }
  if (str.indexOf('12m') >= 0) {
    return 4;
  }
  return 0;
}

function calculateColor(i:number){
  if (i==1) {
    return "#a5a501";
  }
  if (i==2) {
    return "#bebe00";
  }
  if(i==3) {
    return "#e1e101";
  }
  if (i==4) {
    return "#ffff00";
  }
  return "#ffffff";
}

function isClosed(item: LoyaltyDropPoolConfig){
  if(item){
    return item.baseTokens.amount <= new Coin(item.reservedTokens.amount, item.reservedTokens.denom).add(item.usedTokens).amount;
  } else {
    return true;
  }
}

function checkBTN(item: LoyaltyDropPoolConfig){
  currentBoost.value = item;
  popupOpened.value = !popupOpened.value;
  return popupOpened;
}


function createEagerLoadingConfig(): EagerLoadingConfig<LoyaltyDropPoolConfig>{
  const boosts = boostStore.getBoosts;
  const config = new EagerLoadingConfig<LoyaltyDropPoolConfig>(boosts);
  return config;
}

function onRowExpand(data: LoyaltyDropPoolConfig) {
  expandedRow.value = (expandedRow.value.length && expandedRow.value[0].poolDescription === data.poolDescription) ? [] : [data];
}

function onRowClick(event: any) {
    onRowExpand(event.data);
}

function calculatePoolUsageTokens(data: LoyaltyDropPoolConfig){
  return new Coin(data.reservedTokens.amount, data.reservedTokens.denom).add(data.usedTokens);
}

function calculatePercentagePoolUsage(data: LoyaltyDropPoolConfig): BigDecimal {
  return divideBigInts(data.reservedTokens.amount + data.usedTokens.amount, data.baseTokens.amount);
}

function calculateContributionPerPool(userBoosts: LoyaltyDropUserBoost[], poolId: number) {
  console.log("calculateContributionPerPool poolId:" + poolId);
  const temp = userBoosts.filter(el => el.boostPoolId === poolId);
  const tempCoin = new Coin(0n, "uc4e");
  if (temp && temp.length > 0) {
    temp.forEach((el) => {
      tempCoin.add(el.amount);
    });
  }
  return tempCoin;
}

const isActive = (data: LoyaltyDropPoolConfig) => {
  return data.epochStartDate.getTime() < new Date().getTime();
};

function calculateRewardsPerPool(userBoosts: LoyaltyDropUserBoost[], poolId: number) {
  console.log("calculateRewardsPerPool poolId:" + poolId);
  const temp = userBoosts.filter(el => el.boostPoolId === poolId);
  const tempCoin = new Coin(0n, "uc4e");
  if (temp && temp.length > 0) {
    temp.forEach((el) => {
      if(el.grantedRewards) {
        tempCoin.add(el.grantedRewards);
      }
    });
  }
  return tempCoin;
}

function msToDays(milliseconds:  number) {
  return  Math.floor(milliseconds / (1000 * 60 * 60 * 24));
}

function createUserDropLoadingConfig(id: number){
  const config = new EagerLoadingConfig<LoyaltyDropUserBoost>(boostStore.getUserBoosts.filter(el => el.boostPoolId === id));
  return config;
}

function checkDateIsDefined(date: Date | null) {
  if (date) {
    return date.toLocaleDateString();
  } else {
    return "-";
  }
}

const calcTimeToStart = ((time: Date) => {
  return time.getTime() - new Date(Date.now()).getTime();
});



const __returned__ = { transactionSuccess, popupOpened, currentBoost, userStore, boostStore, isLoggedIn, expandedRow, test, calculateRockets, calculateColor, isClosed, checkBTN, createEagerLoadingConfig, onRowExpand, onRowClick, calculatePoolUsageTokens, calculatePercentagePoolUsage, calculateContributionPerPool, isActive, calculateRewardsPerPool, msToDays, createUserDropLoadingConfig, checkDateIsDefined, calcTimeToStart, DataTableWrapper, CoinAmount, PercentsView, LoyaltyDropPopup, get calculateApr() { return calculateApr }, get calculatePayouts() { return calculatePayouts }, BoosterCounter, StatusBadge, Icon }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})